import React, { useState } from "react";
import { useWebData } from "../../Context/webDataContext";

import img1 from "../../aseets/about/img1.svg";
import img1h from "../../aseets/about/img1h.svg";
import img2 from "../../aseets/about/img2.svg";
import img2h from "../../aseets/about/img2h.svg";
import img3 from "../../aseets/about/img3.svg";
import img3h from "../../aseets/about/img3h.svg";
import img4 from "../../aseets/about/img4.svg";
import img4h from "../../aseets/about/img4h.svg";

// Image map
const iconMap = {
  1: { normal: img1h, hover: img1 },
  2: { normal: img2h, hover: img2 },
  3: { normal: img3h, hover: img3 },
  4: { normal: img4h, hover: img4 },
};

function AboutUs() {
  const { getAboutUsData } = useWebData();
  const aboutData = getAboutUsData();

  const [hoveredCard, setHoveredCard] = useState(null); // tracks which card is hovered

  if (!aboutData || Object.keys(aboutData).length === 0) {
    return (
      <section className="bg-white manrope flex flex-col items-center justify-center p-4" id="about">
        <p>No About Us data available.</p>
      </section>
    );
  }

  return (
    <section className=" manrope flex flex-col items-center justify-center lg:space-y-12 lg:py-12" id="about">
      <h2 className="manrope text-center text-2xl lg:text-4xl font-bold text-[#08875D] md:mb-8 mb-2">
        {aboutData.heading || "About Us"}
      </h2>
      <p className="text-center text-base lg:text-xl leading-8 max-w-3xl">
        {aboutData.description ||
          "Maideaze is a modern home services platform dedicated to simplifying your life by connecting you with reliable, verified professionals for all your household needs."}
      </p>

      <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:mt-2 md:mt-8 mt-4">
        {aboutData.cards &&
          aboutData.cards.map((item) => {
            const imagePair = iconMap[item.id] || iconMap[1]; // fallback to img1

            return (
              <div
                key={item.id}
                className="group relative rounded-2xl bg-white border-[0.5px] border-[#B5E4CA] lg:p-6 p-3 shadow-sm transition-all duration-300 cursor-pointer hover:bg-[radial-gradient(104.71%_69.4%_at_73.87%_69.4%,_#1D9D67_0%,_#1E8157_21.75%,_#1F6546_51.09%,_#1F573E_72.69%,_#204533_100%)] hover:shadow-[0_8px_16px_rgba(0,0,0,0.1)]"
                onMouseEnter={() => setHoveredCard(item.id)}
                onMouseLeave={() => setHoveredCard(null)}
              >
                {/* Icon */}
                <div className="flex justify-center mb-4">
                  <div className="lg:w-16 lg:h-16 w-12 h-12 rounded-md bg-green-100 flex items-center justify-center group-hover:bg-transparent transition duration-300">
                    <img
                      src={hoveredCard === item.id ? imagePair.hover : imagePair.normal}
                      alt={item.title}
                      className="w-full h-full object-contain"
                    />
                  </div>
                </div>

                {/* Title */}
                <h3 className="md:text-xl text-lg font-semibold text-gray-800 text-center mb-3 transition-colors duration-300 group-hover:text-white">
                  {item.title}
                </h3>

                {/* Description or Values */}
                {item.values ? (
                  <ul className="text-center text-gray-600 text-sm transition-colors duration-300 group-hover:text-white space-y-1">
                    <li className="font-semibold">What We Stand For:</li>
                    {item.values.map((val, idx) => (
                      <li key={idx} className="text-left lg:ml-16">• {val}</li>
                    ))}
                  </ul>
                ) : (
                  <p className="text-center text-gray-600 md:text-base text-sm transition-colors duration-300 group-hover:text-white">
                    {item.description}
                  </p>
                )}
              </div>
            );
          })}
      </div>
    </section>
  );
}

export default AboutUs;
